<template>
    
        <v-card class="card-shadow">
            <v-card-text class="pa-0">
                <v-row no-gutters>
                    <v-col cols="4" class="pl-4" style="margin-top:-40px">
                        <div class="d-flex justify-space-between">
                            <div style="width:120px; height:120px" v-if="doctor.profile_image_path">
                                <div class="round_img" :style="{ 'background-image': 'url(' + apiUrl +'/storage/'+doctor.profile_image_path + ')' }" style="box-shadow:0px 0px 2px 1px #4d4d4d; border-radius:2000px;">
                                </div>
                            </div>          
                            <div style="width:120px; height:120px" v-else>       
                                <div class="round_img" style="background-image: url('/general/book_profile_placeholder.svg')">
                                </div>                                                               
                            </div>                                             
                        </div>
                    </v-col>
                    <v-col offset="2" cols="6" class="d-flex justify-end">                                                    
                        <div style="height:50px;width:150px;" class=" ribbon-container">                            
                            <div class="d-flex flex-column align-center justify-center lightgray px-2">                                
                                    <span class="font-16 weight-bold secondaryVariant--text">
                                        ₹ {{fee}}
                                    </span>
                                    <span class="font-8 weight-bold secondaryVariant--text">
                                        {{getFeeMessage()}}
                                    </span>
                            </div> 
                        </div>
                        
                    </v-col>
                </v-row>
                
                <br>
                <v-row no-gutters class="px-4">
                    <v-col cols="8">
                        <h2 class="my-2 darkergray--text weight-bold font-20">{{ doctor.salutation }} {{ doctor.name }}</h2>
                        <h4 class="font-14 weight-semibold darkgray--text">
                            <span v-for="specialization in doctor.specializations"
                                :key="specialization.id">
                                {{ specialization.name }}
                            </span>
                        </h4>                                    
                        <div v-if="doctor.professional_exp" class="mt-1 font-14 weight-regular darkgray--text">{{ doctor.professional_exp }} years of professional experience</div>
                        <div v-else class="mt-1 font-14 weight-regular darkgray--text">Experience not mentioned</div>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-end">
                        <div class="pr-2 d-flex flex-column justify-start align-end">
                            <span class="">                                                
                                <v-chip label color="red lighten-5" small
                                        class="red--text ma-0 pa-2"
                                        v-if="doctor.percent_recommended > 0 && doctor.percent_recommended <50">
                                        <v-avatar left tile size="5" class="ma-0 pa-0">
                                            <v-icon style="font-size:18px" class="ma-0 pa-0">mdi-thumb-up</v-icon>
                                        </v-avatar>
                                    <span class="font-12 weight-semibold">{{ doctor.percent_recommended }}%</span>
                                </v-chip>                                                       
                                <v-chip label color="green lighten-5" small
                                        class="green--text ma-0 pa-2"
                                        v-else-if="doctor.percent_recommended >= 50">
                                        <v-avatar left tile size="5" class="ma-0 pa-0">
                                            <v-icon style="font-size:16px" class="ma-0 pa-0">mdi-thumb-up</v-icon>
                                        </v-avatar>
                                    <span class="font-12 weight-semibold">{{ doctor.percent_recommended }}%</span>
                                </v-chip>
                            </span>
                            <span class="font-10 weight-semibold green--text ml-2 mt-3">{{ getRecommendations(doctor) }} </span>
                        </div>
                    </v-col>
                </v-row>
                
                <div v-if="clinic && appointment_type === 'clinic'" class="px-4">
                    <br>
                    <div class="d-flex justify-space-between align-center">
                        <div class="d-flex align-center">
                            <v-icon class="font-18 pa-0 ma-0" color="primary" medium right>mdi-map-marker</v-icon>
                            <span class="primary--text weight-medium font-16 ml-1">
                                {{ clinic.name }}
                            </span>
                        </div>
                        
                        <v-btn v-if="show_map_btn" @click.prevent="openMap(clinic)" x-small class="accent white--text ">
                            View On Map
                        </v-btn>    
                    </div>                                        
                    <div class="ml-5 font-14 weight-light">
                        {{clinic.address }}
                    </div>     
                </div>
                <br>
                <div>
                    <v-list two-line subheader class="mb-0 pb-0" style="background:#f4f9ff">
                        <v-list-item class="px-4">
                            <v-list-item-avatar color="white lighten-5 " tile class="d-flex flex-column" style="width:45px !important; height:45px !important">
                                <!--                                                    <v-icon color="primary" large>mdi-calendar-range</v-icon>-->
                                <div>
                                    <div class="darkergray--text font-15 weight-semibold">
                                        {{ moment(date).format('DD') }}
                                    </div>
                                </div>
                                <div>
                                    <div class="darkergray--text font-14 weight-semibold">
                                        {{ moment(date).format('MMM') }}
                                    </div>
                                </div>
                                
                                
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title v-if="start_time" class="font-14 weight-regular darkergray--text"> {{ dateutils.utcToLocal(start_time).format('hh:mm A') }} to {{ dateutils.utcToLocal(end_time).format('hh:mm A') }}</v-list-item-title>
                                <v-list-item-title v-else class="font-14 weight-regular darkergray--text">Select Time</v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-chip v-if="appointment_type == 'clinic'" label class="secondaryVariant white--text" small>Clinic
                                        Consultation
                                    </v-chip>
                                    <v-chip v-else label class="secondaryVariant white--text" small>Online
                                        Consultation
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        
                        
                    </v-list>
                    
                </div>
            </v-card-text>
        </v-card>
</template>

<script>
import {mapGetters} from 'vuex';

    export default {
        name: "DoctorCard",
        
        computed: {
            ...mapGetters([          
                'userInfo'
            ]),
        },
        props: ['doctor','appointment_type','fee','appointment','clinic','show_map_btn','start_time','end_time','date'],
        
        data() {            
               return{
                   apiUrl:process.env.VUE_APP_API_URL,
               }
        },
        methods: {
            openMap(clinic){
                var link ='https://www.google.com/maps/search/?api=1&query=' + clinic.latitude + ',' + clinic.longitude
                window.open(link);                
            },
            getRecommendations(doctor){
                var count = doctor.total_ratings;
                if(count == null || count == undefined)
                count = 0
                if(count == 0)
                    return "No Recommendation"
                else
                    return count + " Recommendations"                                
            },
            
            getFeeMessage(){
                
                if(this.appointment_type === 'clinic'){
                    return "Clinic Consultation Fee";
                }
                else if(this.appointment_type === 'online'){
                    return "Online Consultation Fee";
                }
                
            },
        },
        mounted(){
            console.log("doctor")
            console.log(this.doctor)
        
        }                         
    }
</script>